<template>
  <el-form
    v-loading.fullscreen.lock="fullscreenLoading"
    ref="formTask"
    :model="model"
    :rules="rules"
    label-position="top"
    class="tasks-form padding-20"
    @submit.native.prevent="onSubmit">
    <el-row>
      <el-col :span="24">
        <h5>Creado por:&nbsp;&nbsp;<b>{{ profile.name }}</b></h5>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-form-item
          label="Título de la tarea"
          prop="title">
          <el-input v-model="model.title"/>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-form-item
          label="Descripción"
          prop="description">
          <el-input
            v-model="model.description"
            :rows="4"
            resize="none"
            type="textarea"/>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item
          label="Vencimiento"
          prop="dueDate">
          <el-date-picker
            v-model="model.dueDate"
            type="date"
            placeholder="Seleccione una fecha"
            style="width: 100%;"/>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          label="Oportunidad"
          prop="oportunity">
          <el-select
            v-model="model.opportunityId"
            placeholder="Elija una oportunidad">
            <el-option
              v-for="(oportunity, index) in opportunities"
              :key="index"
              :label="oportunity.label"
              :value="oportunity.value"/>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item
          label="Recordarme"
          prop="reminder">
          <el-switch v-model="model.reminder"/>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-button
          type="primary"
          native-type="submit">
          Guardar
        </el-button>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import TasksModel from '@/models/tasks/tasks.model'
export default {
  name: 'TasksForm',
  props: {
    old: {
      type: Object,
      default: null
    },
    customer: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      model: TasksModel.model(),
      rules: TasksModel.rules(),
      text: '',
      opportunities: [],
      fullscreenLoading: false
    }
  },
  computed: {
    profile () {
      return this.$store.getters['profile/me']
    }
  },
  mounted () {
    if (this.old !== null) {
      this.model = Object.assign({}, this.model, this.old)
    }
    let filters = {
      limit: 1000
    }
    if (this.customer) {
      filters['filters[where][customerId][eq]'] = this.customer.id
    }
    this.$store.dispatch('opportunities/query', { ...filters })
      .then(response => {
        for (let opportunity of (response.data.items)) {
          this.opportunities.push({
            label: opportunity.title,
            value: opportunity.id
          })
        }
      })
      .catch(e => {
        console.log(e)
      })
  },
  methods: {
    onSubmit () {
      this.$refs['formTask'].validate((valid) => {
        this.fullscreenLoading = true
        if (valid) {
          if (this.customer) {
            this.model.customerId = this.customer.id
          }
          this.$store.dispatch('tasks/save', this.model)
            .then(response => {
              let filters = {}
              if (this.customer) {
                filters['filters[where][customerId][eq]'] = this.customer.id
              }
              this.$store.dispatch('tasks/query', { ...filters, ...this.$route.query })
                .then(({data}) => {
                  this.$store.dispatch('app/toggleTasksPanel')
                })
            })
            .catch(error => {
              this.$notify.error({
                group: 'app',
                title: 'Error al crear la tarea.',
                message: 'Por favor, vuelve a intentarlo.'
              })
              return Promise.reject(error)
            })
            .finally(() => {
              this.fullscreenLoading = false
            })
        } else {
          this.$notify.error({
            group: 'app',
            title: 'Verifica el formulario.',
            message: 'Por favor, revisa los errores que se indican dentro del formulario.'
          })
          this.fullscreenLoading = false
          return false
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.tasks-form{
  .el-button {
    background-color: $primary;
    color: #ffffff;
    width: 100%;
    box-shadow: 0 3px 6px 0 rgba(231, 18, 14, 0.5);
  }
  h5{
    margin-left: 10px;
    @include font-lato(14px, regular);
    color: #3E3E3E;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/tasks/tasks-form.vue